import events from "/events";
import { sendUniqEvent } from "/services/tracking/gtm";
import featureFlags from "/utils/feature-flags";
import store from "/store";

// This is a global Cookiebot callback which is fired when user 1st time
// accepts consent and on every subsequent page load
// https://support.cookiebot.com/hc/en-us/articles/360003793854-Google-Tag-Manager-deployment

const informAboutCookieConsent = () => {
  if (window.Cookiebot.consent.preferences) {
    sendUniqEvent({ "event": "cookieconsent_preferences" });
  }

  if (window.Cookiebot.consent.statistics) {
    sendUniqEvent({ "event": "cookieconsent_statistics" });
  }

  if (window.Cookiebot.consent.marketing) {
    sendUniqEvent({ "event": "cookieconsent_marketing" });
  }

  // On IE11, occasionally events is undefined here, which interferes with
  // other scripts (like the page-loader and ab test toggler).
  // https://github.com/blinkist/blinkist-web/pull/2276
  if (typeof events !== "undefined") {
    events.emit("cookiebot:accept");
  }
};

// Check whether we were slower than Cookiebot and therefore missed the event
if (window.Cookiebot && window.Cookiebot.consented) {
  informAboutCookieConsent();
} else {
  window.addEventListener("CookiebotOnAccept", () => informAboutCookieConsent(), { once: true });
}

if (featureFlags.enabled("custom_cookie_consent")) {
  // While we develop the new cookie banner, we need to prevent the old one to show up
  // TODO Remove the following block once the new banner is up and running
  window.addEventListener("CookiebotOnDialogDisplay", () => {
    const banner = document.getElementById("cookiebanner");
    banner.parentNode.removeChild(banner);
  });

  if (window.Cookiebot) {
    // Dispatched when user did not submitted consent yet
    window.addEventListener("CookiebotOnDialogInit", () => {
      store.commit("cookiesSubmitted", false);
    });

    // Dispatched when user has submited consent (accepted or not)
    window.addEventListener("CookiebotOnLoad", () => {
      store.dispatch("initCookies", {
        consented: window.Cookiebot.consented,
        options: { ...window.Cookiebot.consent }
      });
    });
  }
}

export const hasStatisticsConsent = () => {
  return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics;
};

export const consent = (options) => {
  window.Cookiebot.submitCustomConsent(options.preferences, options.statistics, options.marketing);
};
